// Suppress ResizeObserver errors at the source
export function suppressResizeObserverError() {
  if (typeof window !== 'undefined' && window.ResizeObserver) {
    console.log('[ResizeObserver Suppression] Patching ResizeObserver...');
    
    const originalResizeObserver = window.ResizeObserver;
    
    window.ResizeObserver = class ResizeObserver extends originalResizeObserver {
      constructor(callback) {
        const wrappedCallback = (entries, observer) => {
          try {
            callback(entries, observer);
          } catch (error) {
            if (
              error.message?.includes('ResizeObserver loop limit exceeded') ||
              error.message?.includes('ResizeObserver loop completed with undelivered notifications')
            ) {
              console.log('[ResizeObserver Suppression] Caught and suppressed ResizeObserver error');
              // Silently ignore these specific errors
            } else {
              // Re-throw other errors
              throw error;
            }
          }
        };
        super(wrappedCallback);
      }
    };
    
    console.log('[ResizeObserver Suppression] ResizeObserver patched successfully');
  }
}

// Also add a global error handler specifically for ResizeObserver
export function addResizeObserverErrorHandler() {
  if (typeof window !== 'undefined') {
    // Catch errors that might escape the ResizeObserver patch
    const errorHandler = (event) => {
      if (
        event.message?.includes('ResizeObserver loop limit exceeded') ||
        event.message?.includes('ResizeObserver loop completed with undelivered notifications') ||
        event.error?.message?.includes('ResizeObserver loop limit exceeded') ||
        event.error?.message?.includes('ResizeObserver loop completed with undelivered notifications')
      ) {
        console.log('[ResizeObserver Suppression] Caught ResizeObserver error in global handler');
        event.stopImmediatePropagation();
        event.preventDefault();
        return true;
      }
    };
    
    // Add handler with highest priority (capture phase)
    window.addEventListener('error', errorHandler, true);
    
    // Also handle it in the bubble phase
    window.addEventListener('error', errorHandler, false);
  }
}